<p-table
    [value]="dataset"
    [sortField]="defaultSort"
    [sortOrder]="sortOrder"
    [(first)]="pageNumber"
    [rows]="rowsToDisplay"
    [paginator]="paginator"
    (onRowSelect)="onRowSelect($event)"
    (onRowUnselect)="onRowUnselect($event)"
    (onHeaderCheckboxToggle)="onHeaderCheckboxToggle($event)"
    (onPage)="onPage($event)"
    [rowsPerPageOptions]="getRowsPerPage()"
    [scrollable]="scrollable"
    [scrollHeight]="scrollHeight"
    [selectionMode]="selectionMode"
    [selection]="getSelected()"
    currentPageReportTemplate="Records: {first} - {last} of {totalRecords}"
    [showCurrentPageReport]="true"
    [ngClass]="hideSelectAll == true ? 'hideSelectAll' : ''"
    [loading]="loading"
    [tableStyle]="{ 'min-width': getTableMinWidth() }"
    #dt
>
    <ng-template pTemplate="colgroup">
        <colgroup>
            <ng-container *ngFor="let column of columns; let j = index">
                <col
                    *ngIf="column.visible != false"
                    [style]="getColStyle(column, j)"
                />
            </ng-container>
        </colgroup>
    </ng-template>
    <ng-template *ngIf="showCaption" pTemplate="caption">

    <div class="row">
        <div class="col-md-9 col-sm-12 p-2">
            <div class="btn-group">            
                <button
                type="button"
                class="btn btn-outline-secondary floatRight"
                pTooltip="Refresh"
                (click)="onRefreshTable(tableCount)">
                <fa-icon [icon]="faRefresh"></fa-icon>
            </button>
           
                <button
                    type="button"
                    class="btn btn-outline-secondary floatRight"
                    pTooltip="Apply Filter"
                    (click)="openFilterRegisterModal()"
                    *ngIf="showFilter">
                    <i class="pi pi-filter fw-bold"></i>
                    <span class="lock-badge"><fa-icon *ngIf="isRegisterFilterLocked" [icon]="faLock"></fa-icon></span>
                </button>
                <button
                    type="button"
                    class="btn btn-outline-secondary floatRight"
                    pTooltip="Clear Filter"
                    *ngIf="showClearFilter"
                    (click)="onClearFilter()">
                    <i class="pi pi-filter-slash fw-bold"></i>
                </button>

                <form class="width100">
                    <p-chips 
                        class="w-auto width100"
                        *ngIf="showrREQFilter"
                        placeholder="Search Req #" 
                        type="submit"
                        [allowDuplicate]="false"
                        (onAdd)="onAddItem($event)"
                        (onRemove)="onRemoveItem($event)"
                        separator="," 
                        [addOnTab]="true" 
                        [addOnBlur]="true">
                        <ng-template let-item pTemplate="item">
                            Req #{{ item }}
                        </ng-template>
                    </p-chips>
                </form>
            </div>
        </div>
            <div class="col-md-3 col-sm-6 p-2">
            <input
                class="form-control float-end"
                placeholder="Search Records"
                type="search"
                (input)="onSearchTextChange($event.target.value, tableCount)"
                />
            <span id="searchclear" class="glyphicon glyphicon-remove-circle"></span>
        </div>
    </div>           
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <ng-container *ngFor="let column of columns; let j = index">
                <th
                    *ngIf="column.visible != false"
                    [pSortableColumn]="column.sortable ? column.value : null"
                    [style]="getStyle(column, j)"
                    [ngClass]="getColumnHeaderClass(column)"
                >
                    <div class="display-flex flex-row">
                        <span
                            class="w-100"
                            *ngIf="
                                !(
                                    hasOptions(column) ||
                                    column.type == 'CheckBox'
                                ) && column.header
                            "
                            >{{ column.header }}</span
                        >
                        <ng-container *ngIf="hasOptions(column) && showExport">
                            <button
                                class="btn btn-link"
                                type="button"
                                title="Export Table"
                                style="color: #333"
                                (click)="export()"
                            >
                                <fa-icon [icon]="faDownload"></fa-icon>
                            </button>
                        </ng-container>
                        <ng-container *ngIf="column.type == 'Attachments'">
                            <div class="w-100">
                                <fa-icon
                                    class="text-center"
                                    [icon]="faPaperclip"
                                    pTooltip="{{ column.tooltip }}"
                                ></fa-icon>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="column.type == 'CheckBox'">
                            <div class="d-flex mx-auto">
                                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="column.sortable">
                            <fa-icon
                                class="flex-1 text-end ms-1"
                                [icon]="faSort"
                            ></fa-icon>
                        </ng-container>
                    </div>
                </th>
            </ng-container>
        </tr>
        <tr *ngIf="areAnyColumnsFilterable(columns)">
            <ng-container *ngFor="let column of columns; let j = index">
                <th
                    *ngIf="column.visible != false"
                    [style]="getStyle(column, j)"
                    [ngClass]="getColumnHeaderClass(column)"
                    class="p-1"
                >
                    <ng-container *ngIf="column.filterable">
                        <ng-container
                            *ngIf="
                                !(
                                    !column.filterType &&
                                    column.type == 'DropDown' || column.type == 'MultiHyperLink' || column.type == 'DRHyperLink'
                                )
                            "
                        >
                            <input
                                pInputText
                                   type="text"
                                   (click)="preventDefault($event)"
                                   (input)="
                                    dt.filter(
                                        $event.target.value,
                                        column.value,
                                        'contains'
                                    )
                                "
                                   [value]="dt.filters[column.value] ? dt.filters[column.value].value : ''"
                                class="p-column-filter"
                            />
                        </ng-container>

                        <ng-container
                            *ngIf="
                                column.filterType && column.type == 'DRHyperLink'
                            "
                        >
                            <input
                                pInputText
                                type="text"
                                (click)="preventDefault($event)"
                                (input)="
                                    dt.filter(
                                        $event.target.value,
                                        'originalFileName',
                                        'contains'
                                    )
                                "
                                [value]="dt.filters[column.value] ? dt.filters[column.value].value : ''"
                                class="p-column-filter"
                            />
                        </ng-container>

                        <ng-container
                            *ngIf="
                                !column.filterType && column.type == 'DropDown'
                            "
                        >
                            <p-dropdown
                                [options]="getOptions(null, column)"
                                [editable]="column.filterable"
                                (onChange)="
                                    dt.filter(
                                        $event.value,
                                        column.value,
                                        column.filterMatchMode
                                    )
                                "
                                appendTo="body"
                                placeholder="All"
                                styleClass="ui-column-filter p-column-filter"
                            ></p-dropdown>
                        </ng-container>
                    </ng-container>
                </th>
            </ng-container>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item let-itemIndex>
        <tr
            [ngClass]="{
                'ui-state-highlight ': isRowSelected(item, columns),
                highlighted: isRowHighlighted(item, columns)
            }"
            [style]="getRowStyle(column, j, item)"
        >
            <ng-container *ngFor="let column of columns; let j = index">
                <td
                    *ngIf="column.visible != false && !item.isDeleted"
                    [ngClass]="column.styleClass"
                    [class.highlighted]="isColumnHighlighted(column, item)"
                    [style]="getStyle(column, j, item)"
                >
                    <ng-container *ngIf="column.editable">
                        <ng-container *ngIf="disabledCheck(item, column)">
                            <ng-container
                                *ngIf="
                                    column.type == 'Text' ||
                                    !column.type ||
                                    column.type == 1 ||
                                    column.type == 'DropDown' ||
                                    column.type == 'Textarea'
                                "
                            >
                                <span class="wrap-text">
                                    {{ getDisplayText(item, column) }}
                                    <a
                                        *ngIf="isTextTruncatable(item, column)"
                                        href="#"
                                        class="btn-link d-block show-more-toggle"
                                        (click)="toggleTextExpanded($event, item, column)"
                                        >{{ isTextExpanded(item, column) ? "Show Less" : "Show More" }}</a
                                    >
                                </span>
                            </ng-container>
                            <ng-container *ngIf="column.type == 'Email'">
                                <span class="wrap-text">
                                    <a
                                        class="btn-link"
                                        href="mailto:{{ item[column.value] }}"
                                        >{{ item[column.value] }}</a
                                    >
                                </span>
                            </ng-container>
                            <ng-container *ngIf="column.type == 'Tel'">
                                <span class="wrap-text">
                                    <a
                                        class="btn-link"
                                        href="tel:{{ item[column.value] }}"
                                        >{{ item[column.value] }}</a
                                    >
                                </span>
                            </ng-container>
                            <ng-container *ngIf="column.type == 'Boolean'">
                                <span class="wrap-text">
                                    {{ item[column.value] ? "Yes" : "No" }}
                                </span>
                            </ng-container>
                            <ng-container *ngIf="column.type == 'Number'">
                                <span class="wrap-text">
                                    {{
                                        item[column.value]
                                            | number: column.numberPipe
                                    }}
                                </span>
                            </ng-container>
                            <ng-container *ngIf="column.type == 'Currency'">
                                <span class="wrap-text">
                                    {{
                                        item[column.value]
                                            | number: column.numberPipe
                                    }}
                                </span>
                            </ng-container>
                            <ng-container
                                *ngIf="
                                    column.type == 'Percentage' ||
                                    column.type == 8
                                "
                            >
                                <span class="wrap-text">
                                    {{ item[column.value] | number: "1.0-2" }}
                                    %
                                </span>
                            </ng-container>
                            <ng-container
                                *ngIf="
                                    column.type == 'CheckBox' ||
                                    column.type == 'SelectBox'
                                "
                            >
                                <div class="d-flex mx-auto">
                                    <p-checkbox
                                        [(ngModel)]="item[column.value]"
                                        [disabled]="true"
                                        binary="true"
                                    ></p-checkbox>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="column.type == 'Time'">
                                <input
                                    type="time"
                                    showIcon="true"
                                    [(ngModel)]="item[column.value]"
                                    [required]="getRequired(item, column)"
                                    styleClass="form-control"
                                    (ngModelChange)="modelChanged($event, item)"
                                />
                            </ng-container>
                            <ng-container *ngIf="column.type == 'Date'">
                                {{ item[column.value] | date: column.format }}
                            </ng-container>
                            <ng-container *ngIf="column.type == 'Thumbnail'">
                                <img
                                    *ngIf="!openImageInNewWindow"
                                    [src]="getColumnSrc(item, column, true)"
                                    target="_blank"
                                    data-bs-toggle="modal"
                                    (click)="
                                        changeModalImage(
                                            item[column.value],
                                            getColumnSrc(item, column)
                                        )
                                    "
                                    [attr.data-bs-target]="'#image-modal'"
                                    class="img-thumbnail"
                                />
                                <a
                                    *ngIf="openImageInNewWindow"
                                    [href]="getColumnSrc(item, column)"
                                    target="_blank"
                                >
                                    <img
                                        [src]="getColumnSrc(item, column, true)"
                                        class="img-thumbnail"
                                    />
                                </a>
                            </ng-container>
                            <ng-container
                                *ngIf="
                                    column.type == 'HyperLink' && !item.isFolder
                                "
                            >
                                <a
                                    [href]="getColumnHref(item, column)"
                                    target="_blank"
                                    class="btn btn-sm btn-link"
                                >
                                    {{
                                        item[column.linkName] ||
                                            getLinkName(
                                                item,
                                                item[column.value]
                                            )
                                    }}
                                </a>
                            </ng-container>
                            <ng-container
                                *ngIf="
                                    column.type == 'HyperLink' && item.isFolder
                                "
                            >
                                <span
                                    class="btn btn-sm btn-link"
                                    style="width: 100%"
                                >
                                    {{
                                        item[column.linkName] ||
                                            getLinkName(
                                                item,
                                                item[column.value]
                                            )
                                    }}
                                </span>
                            </ng-container>
                            <ng-container *ngIf="column.type == 'Button'">
                                <button
                                    class="btn btn-link"
                                    *ngFor="
                                        let option of getOptions(item, column)
                                    "
                                    (click)="
                                        option.click(
                                            option.controller,
                                            option.id,
                                            item
                                        )
                                    "
                                >
                                    {{ item[column.value] }}
                                </button>
                            </ng-container>
                        </ng-container>
                        <ng-container *ngIf="!disabledCheck(item, column)">
                            <ng-container *ngIf="column.type == 'Textarea'">
                                <textarea
                                    [(ngModel)]="item[column.value]"
                                    (change)="textAreaChanged($event, item)"
                                    (keyup)="textAreaChanged($event, item)"
                                    style="height: 32px"
                                    class="form-control"
                                    pInputTextarea
                                    autoResize="true"
                                    rows="1"
                                    cols="30"
                                ></textarea>
                            </ng-container>
                            <ng-container
                                *ngIf="
                                    column.type == 'Text' ||
                                    !column.type ||
                                    column.type == 1 ||
                                    column.type == 'Email'
                                "
                            >
                            <input
                                class="form-control"
                                [required]="getRequired(item, column)"
                                (ngModelChange)="modelChanged($event, item)"
                                [(ngModel)]="item[column.value]"
                                (keyup.enter)="preventDefault($event)"
                                (keydown.enter)="preventDefault($event)"
                                pInputText
                            />
                            </ng-container>
                            <ng-container
                                *ngIf="
                                    column.type == 'Currency' ||
                                    column.type == 'Number' ||
                                    column.type == 'Percentage' ||
                                    column.type == 8 ||
                                    column.type == 6
                                "
                            >
                                <input
                                    class="form-control text-end"
                                    type="number"
                                    [required]="getRequired(item, column)"
                                    [min]="column.min"
                                    [max]="column.max"
                                    [step]="column.step || 'any'"
                                    (ngModelChange)="modelChanged($event, item)"
                                    (keyup.enter)="preventDefault($event)"
                                    (keydown.enter)="preventDefault($event)"
                                    (keyup.arrowup)="preventDefault($event)"
                                    (keydown.arrowup)="preventDefault($event)"
                                    (keyup.arrowdown)="preventDefault($event)"
                                    (keydown.arrowdown)="preventDefault($event)"
                                    (input)="onInput($event, item, column.value)"
                                    (keydown)="onKeyDown($event)"
                                    (paste)="onPaste($event)"
                                    [(ngModel)]="item[column.value]"
                                    (onChange)="numberChanged($event, item)"
                                    onwheel="return false;"
                                    pInputText
                                />
                            </ng-container>
                            <ng-container *ngIf="column.type == 'Tel'">
                                <input
                                    class="form-control"
                                    type="tel"
                                    [required]="getRequired(item, column)"
                                    (ngModelChange)="modelChanged($event, item)"
                                    [(ngModel)]="item[column.value]"
                                    (keyup.enter)="preventDefault($event)"
                                    (keydown.enter)="preventDefault($event)"
                                    pInputText
                                />
                            </ng-container>
                            <ng-container *ngIf="column.type == 'ButtonSelect'">
                                <button
                                    class="
                                        bg-transparent
                                        border-0
                                        btn-link
                                        full-width
                                    "
                                    type="button"
                                    (click)="
                                        buttonSelectClick(item, j, column.value)
                                    "
                                >
                                    {{
                                        item[column.value] || column.options[0]
                                    }}
                                </button>
                            </ng-container>
                            <ng-container *ngIf="column.type == 'DropDown'">
                                <p-dropdown
                                    [filter]="column.filter"
                                    [(ngModel)]="item[column.value]"
                                    [required]="getRequired(item, column)"
                                    [options]="getOptions(item, column)"
                                    appendTo="body"
                                    [editable]="false"
                                    [styleClass]="'form-control'"
                                    [placeholder]="' '"
                                    (onChange)="dropdownChanged($event, item)"
                                ></p-dropdown>
                            </ng-container>
                            <ng-container
                                *ngIf="column.type == 'MultiSelect'">
                                <p-multiSelect
                                    [filter]="column.filter"
                                    [(ngModel)]="item[column.value]"
                                    [required]="getRequired(item, column)"
                                    [options]="getOptions(item, column)"
                                    appendTo="body"
                                    [editable]="false"
                                    [styleClass]="'full-width form-control forms-multiselect'"
                                    [placeholder]="''"
                                    [showClear]="false"
                                    (onChange)="dropdownChanged($event, item)"
                                ></p-multiSelect>
                            </ng-container>
                            <ng-container
                                *ngIf="
                                    column.type == 'CheckBox' ||
                                    column.type == 'SelectBox'
                                "
                            >
                                <div class="text-center mx-auto">
                                    <p-checkbox
                                        [(ngModel)]="item[column.value]"
                                        (onChange)="
                                            checkedChange(
                                                $event,
                                                item,
                                                column.value,
                                                column.disableCheck
                                            )
                                        "
                                        binary="true"
                                    ></p-checkbox>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="column.type == 'Time'">
                                <input
                                    type="time"
                                    showIcon="true"
                                    [(ngModel)]="item[column.value]"
                                    [required]="getRequired(item, column)"
                                    styleClass="form-control"
                                    (ngModelChange)="modelChanged($event, item)"
                                />
                            </ng-container>
                            <ng-container *ngIf="column.type == 'Date'">
                                <p-calendar
                                    panelStyleClass="table-calendar-mobile modal-calender"
                                    [todayButtonStyleClass]="'p-calender-today-button'"
                                    [clearButtonStyleClass]="'p-calender-clear-button'"
                                    showIcon="true"
                                    [(ngModel)]="item[column.value]"
                                    placeholder="yyyy-mm-dd"
                                    [selectOtherMonths]="true"
                                    styleClass="form-control"
                                    [minDate]="
                                        column.min.constructor.name == 'String'
                                            ? item[column.min]
                                            : column.min
                                    "
                                    [maxDate]="
                                        column.max.constructor.name == 'String'
                                            ? item[column.max]
                                            : column.max
                                    "
                                    appendTo="body"
                                    [readonlyInput]="!column.readonlyInput ? column.readonlyInput : true"
                                    [yearRange]="yearRange"
                                    [showButtonBar]="true"
                                    [monthNavigator]="true"
                                    [yearNavigator]="true"
                                    dateFormat="yy-mm-dd"
                                    (onSelect)="dateSelected($event, item, column.value)"
                                    (onChange)="dateChanged($event, item)"
                                ></p-calendar>
                            </ng-container>
                            <ng-container
                                *ngIf="
                                    column.type == 'Thumbnail' ||
                                    column.type == 'Image'
                                "
                            >
                                <image-markup
                                    [viewURL]="getViewURL(item, column)"
                                    [src]="getColumnSrc(item, column, true)"
                                    [fileName]="
                                        item[column.linkName] ||
                                        getLinkName(item, item[column.value])
                                    "
                                    (onChange)="
                                        imageChanged($event, item, column)
                                    "
                                ></image-markup>
                            </ng-container>
                            <ng-container *ngIf="column.type == 'Button'">
                                <button
                                    class="btn btn-link"
                                    disabled="disabled"
                                    *ngFor="
                                        let option of getOptions(item, column)
                                    "
                                    (click)="
                                        option.click(
                                            option.controller,
                                            option.id,
                                            item
                                        )
                                    "
                                >
                                    {{ item[column.value] }}
                                </button>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="!column.editable">
                        <ng-container
                            *ngIf="
                                column.type == 'Text' ||
                                !column.type ||
                                column.type == 1 ||
                                column.type == 'DropDown' ||
                                column.type == 'Textarea'
                            "
                        >
                            <span class="wrap-text">
                                {{ getDisplayText(item, column) }}
                                <a
                                    *ngIf="isTextTruncatable(item, column)"
                                    href="#"
                                    class="btn-link d-block show-more-toggle"
                                    (click)="toggleTextExpanded($event, item, column)"
                                    >{{ isTextExpanded(item, column) ? "Show Less" : "Show More" }}</a
                                >
                                <span class="tt" *ngIf="item[column.tooltip]">
                                    <fa-icon
                                        class="ms-2"
                                        [icon]="faInfoSign"
                                        pTooltip="{{ item[column.tooltip] }}"
                                        placeholder="Right"
                                    ></fa-icon>
                                </span>
                            </span>
                        </ng-container>
                        <ng-container *ngIf="column.type == 'Email'">
                            <span class="wrap-text">
                                <a
                                    class="btn-link"
                                    href="mailto:{{ item[column.value] }}"
                                    >{{ item[column.value] }}</a
                                >
                            </span>
                        </ng-container>
                        <ng-container *ngIf="column.type == 'Tel'">
                            <span class="wrap-text">
                                <a
                                    class="btn-link"
                                    href="tel:{{ item[column.value] }}"
                                    >{{ item[column.value] }}</a
                                >
                            </span>
                        </ng-container>
                        <ng-container *ngIf="column.type == 'Boolean'">
                            <span class="wrap-text">
                                {{ item[column.value] ? "Yes" : "No" }}
                            </span>
                        </ng-container>
                        <ng-container *ngIf="column.type == 'Number'">
                            <span class="wrap-text">
                                {{
                                    item[column.value]
                                        | number: column.numberPipe
                                }}
                            </span>
                        </ng-container>
                        <ng-container *ngIf="column.type == 'Currency'">
                            <span class="wrap-text">
                                {{
                                    item[column.value]
                                        | number: column.numberPipe
                                }}
                            </span>
                        </ng-container>
                        <ng-container
                            *ngIf="
                                column.type == 'Percentage' || column.type == 8
                            "
                        >
                            <span class="wrap-text">
                                {{ item[column.value] | number: "1.0-2" }}
                                %
                            </span>
                        </ng-container>
                        <ng-container
                            *ngIf="
                                column.type == 'CheckBox' ||
                                column.type == 'SelectBox'
                            "
                        >
                            <div class="d-flex mx-auto">
                                <p-checkbox
                                    [(ngModel)]="item[column.value]"
                                    [disabled]="true"
                                    binary="true"
                                ></p-checkbox>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="column.type == 'Time'">
                            <input
                                type="time"
                                showIcon="true"
                                [(ngModel)]="item[column.value]"
                                [required]="getRequired(item, column)"
                                styleClass="form-control"
                                (ngModelChange)="modelChanged($event, item)"
                            />
                        </ng-container>
                        <ng-container *ngIf="column.type == 'Date'">
                            {{ item[column.value] | date: column.format }}
                        </ng-container>
                        <ng-container *ngIf="isOptionColumn(item, column)">
                            <custom-menu
                                *ngIf="hasVisibleColumns(item, column)"
                                [itemIndex]="itemIndex"
                                [options]="getOptions(item, column)"
                                [datasetLength]="dataset.length"
                                [item]="item"
                            ></custom-menu>
                        </ng-container>
                        <ng-container *ngIf="column.type == 'MultiUrl'">
                            <ng-container
                                *ngFor="let fileUrl of item[column.value]"
                            >
                                <a
                                    [href]="getMultiUrlSrcLink(fileUrl)"
                                    target="_blank"
                                    class="btn btn-sm btn-link wordwrap-link"
                                >
                                    {{ getFileUrlName(fileUrl) }}
                                </a>
                            </ng-container>
                        </ng-container>
                        <ng-container *ngIf="column.type == 'Image'">
                            <img [src]="item[column.value]" />
                        </ng-container>
                        <ng-container *ngIf="column.type == 'MultiImage'">
                            <div
                                class="multi-image-grid"
                                [ngClass]="column.stylingClass"
                            >
                                <ng-container
                                    *ngFor="let image of item[column.value]"
                                >
                                    <a
                                        *ngIf="image.displayOnTable"
                                        [href]="getMultiImageSrcLink(image)"
                                        target="_blank"
                                    >
                                        <img
                                            [src]="
                                                getMultiImageSrc(image, column)
                                            "
                                        />
                                    </a>
                                </ng-container>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="column.type == 'MultiHyperLink'">
                            <ng-container
                                *ngFor="let link of item[column.value]"
                            >
                                <a
                                    [href]="getMultiHyperlinkSrcLink(link)"
                                    target="_blank"
                                    class="btn btn-sm btn-link wordwrap-link"
                                >
                                    {{ getFileName(link) }}
                                </a>
                            </ng-container>
                        </ng-container>
                        <ng-container *ngIf="column.type == 'Thumbnail'">
                            <img
                                *ngIf="!openImageInNewWindow"
                                [src]="getColumnSrc(item, column, true)"
                                target="_blank"
                                data-bs-toggle="modal"
                                (click)="
                                    changeModalImage(
                                        item[column.value],
                                        getColumnSrc(item, column)
                                    )
                                "
                                [attr.data-bs-target]="'#image-modal'"
                                class="img-thumbnail"
                            />
                            <a
                                *ngIf="openImageInNewWindow"
                                [href]="getColumnSrc(item, column)"
                                target="_blank"
                            >
                                <img
                                    [src]="getColumnSrc(item, column, true)"
                                    class="img-thumbnail"
                                />
                            </a>
                        </ng-container>
                        <ng-container
                            *ngIf="
                                (column.type == 'HyperLink' || column.type == 'DRHyperLink') &&
                                item.isUrl != null &&
                                item.isUrl != true &&
                                !item.isFolder
                            "
                        >
                            <span class="wrap-text hyperlink-nourl-text">
                                {{ item.originalFileName || item.fileName }}
                            </span>
                        </ng-container>
                        <ng-container
                            *ngIf="
                                (column.type == 'HyperLink' || column.type == 'DRHyperLink') &&
                                !item.isFolder &&
                                (item.isUrl == null || item.isUrl == true)
                            "
                        >
                            <a
                                [href]="getColumnHref(item, column)"
                                target="_blank"
                                class="btn btn-sm btn-link"
                            >
                                {{
                                    item[column.linkName] ||
                                        getLinkName(item, item[column.value])
                                }}
                            </a>
                            <span *ngIf="item.isFolder" class="btn btn-sm">
                                {{
                                    item[column.linkName] ||
                                        getLinkName(item, item[column.value])
                                }}
                            </span>
                        </ng-container>
                        <ng-container
                            *ngIf="column.type == 'HyperLink' && item.isFolder"
                        >
                            <span
                                class="btn btn-sm btn-link"
                                style="width: 100%"
                            >
                                {{
                                    item[column.linkName] ||
                                        getLinkName(item, item[column.value])
                                }}
                            </span>
                        </ng-container>
                        <ng-container *ngIf="column.type == 'Button'">
                            <button
                                class="btn btn-link"
                                *ngFor="let option of getOptions(item, column)"
                                (click)="
                                    option.click(
                                        option.controller,
                                        option.id,
                                        item
                                    )
                                "
                            >
                                {{ item[column.value] }}
                            </button>
                        </ng-container>
                        <ng-container *ngIf="column.type == 'Attachments'">
                            <attachment-menu
                                *ngIf="hasVisibleAttachments(item, column)"
                                [itemIndex]="itemIndex"
                                [attachments]="getAttachments(item, column)"
                                [datasetLength]="dataset.length"
                                [item]="item"
                            ></attachment-menu>
                        </ng-container>
                    </ng-container>
                </td>
            </ng-container>
        </tr>
    </ng-template>
    <ng-template pTemplate="footer">
        <tr *ngIf="hasFooter()">
            <ng-container *ngFor="let column of columns; let j = index">
                <td
                    [style]="getFooterStyle(column)"
                    *ngIf="column.visible != false"
                >
                    {{ getFooterContent(column) }}
                </td>
            </ng-container>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="columns.length">
                <div *ngIf="isFromFormRegister; then thenBlock else elseBlock"></div>
                <ng-template #thenBlock>
                    No records found. Please, use
                    <button
                        type="button"
                        class="btn btn-outline-secondary"
                        (click)="openFilterRegisterModal()">
                        <i class="pi pi-filter"></i>
                    </button>
                    to find entries
                </ng-template>
                <ng-template #elseBlock>
                    <span class="sticky-value">{{ getEmptyMessage() }}</span>
                </ng-template> 
            </td>
        </tr>
    </ng-template>
</p-table>
